import { getTemplateNavigationLinks } from 'templates/api';
import { RelatedCategoriesModel } from 'templates/types';
import { createWithEqualityFn } from 'zustand/traditional';

type RelatedCategoriesState = {
  relatedCategories: Array<RelatedCategoriesModel> | null;
  isLoading: boolean;
  fetchRelatedCategories: (
    category: string,
    subCategory: string,
    segments?: string[],
  ) => Promise<void>;
};

const useRelatedCategoriesDataStore = createWithEqualityFn<RelatedCategoriesState>(set => ({
  relatedCategories: null,
  isLoading: true,
  fetchRelatedCategories: async (category, subCategory, segments = []) => {
    const headers = {
      segments,
    };
    set({ isLoading: true });
    const relatedCategories = await getTemplateNavigationLinks(category, subCategory, headers);

    set({
      relatedCategories: relatedCategories.response,
      isLoading: false,
    });
  },
}));

export default useRelatedCategoriesDataStore;
